<template>
    <z-basePage :title="'职级充值'" :pop="true">
        <z-backForm :name="'back-add-rank'" :align="true" @save="saveSet" @cancel="backset">
            <!-- BU名称-->
            <div class="back-item">
                <div class="back-title">BU名称</div>
                <div class="back-wrap">
                    <el-select class="top-choose z-mid" rule="noVal" v-tar="sub.bu_id" 
                    v-model="sub.bu_id" 

                    placeholder="请选择">
                        <z-limitOption v-for="item in bu_list" :key="item.id" :value="item.id" :label="item.bu_name">
                        </z-limitOption>
                    </el-select>
                </div>
            </div>
            <!-- 操作类型 -->
            <div class="back-item">
                <div class="back-title">操作类型</div>
                <div class="back-wrap">
                    <el-select class="top-choose z-mid" rule="noVal" v-tar="sub.type" @change="changeRemark" v-model="sub.type" placeholder="请选择">
						<el-option v-for="item in typeArr" :key="item.val" :value="item.val" :label="item.label">
						</el-option>
					</el-select>
                </div>
            </div>
            <!-- 职级数量 -->
            <div class="back-item">
                <div class="back-title">职级数量</div>
                <div class="back-wrap">
                    <el-input class="top-choose z-mid" rule="noVal number" v-tar="sub.num" v-model="sub.num" placeholder="请输入职级数量">
                        <template slot="append">级</template>
                    </el-input>
                </div>
            </div>
            <!-- 备注 -->
            <div class="back-item area">
                <div class="back-title">备注</div>
                <div class="back-wrap">
                    <textarea rule="reason describe_limit" v-arg="'备注'" v-tar="sub.remark" v-model="sub.remark" placeholder="请输入备注"></textarea>
                </div>
            </div>

        </z-backForm>

    </z-basePage>
</template>

<script>
    import { mapState } from "vuex"

    export default {
        data(){
            return {
                typeArr:[
                    {
                        val:1,
                        label:"职级充值",
                    },
                    {
                        val:2,
                        label:"职级扣除",
                    },
                ],
                sub:{
                    bu_id:"",
                    type:"",
                    num:"",
                    remark:"",
                },
            }
        },
        computed:{
            ...mapState(["bu_list"]),
            buId(){
                return this.$crypto.decrypt(this.$route.params.id);
            },
        },
        created(){
            this.$func.getBuList();
            this.sub.bu_id = this.buId;
        },

        beforeRouteLeave(to,from,next){  //离开页面之前
			let res = this.$form.leave({name:'back-add-rank',path:to.path});
			next(res);
        },
        
        methods:{
            changeRemark(type){
                if(type == 1){
                    this.sub.remark = '管理员提升职级';
                }else if(type == 2){
                    this.sub.remark = '管理员撤销职级';
                }
            },
            saveSet(){
                this.$func.loading(true);
                let url = `api/admin/pmt/recharge`;
                this.$http.post(url,{
                    bu_id:this.sub.bu_id, 
                    bill_type: this.sub.type,
                    amount:this.sub.num,
                    remark:this.sub.remark,
                }).then(res=>{
                    if(res.status == 200){
                        this.successTip("充值成功");
                        this.$router.go(-1);
                    }
                    this.$func.loading(false);
                }).catch(err=>{
                    this.errorTip("出错了");
                    this.$func.loading(false);
                });
            },
            backset(dataArr){
                let sub = this.sub;
                [sub.bu_id,sub.type,sub.num,sub.remark] = dataArr;
            },
        },

    }
</script>

<style lang="less">

</style>





// WEBPACK FOOTER //
// page-rank-recharge-add.vue?2b042382